// extracted by mini-css-extract-plugin
module.exports = {"importedColumn":"Column_column__3Ouyu","container":"Container_container__3eFli","centered":"Container_centered__1kNyT"};